export class GetTableDataQualityOverviewResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "dashboard",
            "baseName": "dashboard",
            "type": "DataQualityDashboard",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return GetTableDataQualityOverviewResponse.attributeTypeMap;
    }
    constructor() {
    }
}
